import React from 'react';
import PublicLayout from '../components/public/PublicLayout';
import { PageHero } from './UniversitiesListPage';

// Content adapted from the live EduBridge Network terms page.
const TermsPage = () => (
  <PublicLayout>
    <PageHero title="Terms & Conditions" subtitle="Effective Date: April 07, 2025" />

    <section className="max-w-3xl mx-auto px-4 py-12" data-testid="terms-content">
      <p className="text-gray-600 leading-relaxed">
        Welcome to Edu Bridge Network! By accessing and using our website, services, or resources, you agree to be bound by the following terms and conditions:
      </p>

      <NumberedSection n="1" title="Eligibility">
        <ul className="list-disc pl-6 space-y-1">
          <li>You must be at least 16 years old to use our platform.</li>
          <li>If you're under 18, you must use the platform with parental or guardian consent.</li>
        </ul>
      </NumberedSection>

      <NumberedSection n="2" title="Use of Services">
        <ul className="list-disc pl-6 space-y-1">
          <li>The information provided on our site is for general guidance on study abroad programs.</li>
          <li>You agree not to misuse the platform, including uploading false documents, spam, or misleading information.</li>
        </ul>
      </NumberedSection>

      <NumberedSection n="3" title="User Content">
        <ul className="list-disc pl-6 space-y-1">
          <li>You are responsible for any content (e.g. documents, reviews, questions) you submit.</li>
          <li>We reserve the right to review and remove any content deemed inappropriate or misleading.</li>
        </ul>
      </NumberedSection>

      <NumberedSection n="4" title="Third-Party Links">
        <ul className="list-disc pl-6 space-y-1">
          <li>Our site may contain links to third-party websites or services (e.g. universities, scholarship portals). We are not responsible for their content or privacy practices.</li>
        </ul>
      </NumberedSection>

      <NumberedSection n="5" title="Limitation of Liability">
        <ul className="list-disc pl-6 space-y-1">
          <li>Edu Bridge Network is not liable for admission outcomes, visa rejections, or third-party decisions.</li>
          <li>We do our best to provide accurate and updated information, but we do not guarantee completeness or timeliness.</li>
        </ul>
      </NumberedSection>

      <NumberedSection n="6" title="Intellectual Property">
        <ul className="list-disc pl-6 space-y-1">
          <li>All content, branding, and tools are the property of Edu Bridge Network and may not be used without permission.</li>
        </ul>
      </NumberedSection>

      <NumberedSection n="7" title="Modifications">
        <ul className="list-disc pl-6 space-y-1">
          <li>We reserve the right to update these terms at any time. Continued use means you accept the updated terms.</li>
        </ul>
      </NumberedSection>

      <NumberedSection n="8" title="Governing Law">
        <ul className="list-disc pl-6 space-y-1">
          <li>These terms are governed by the laws of the jurisdiction in which Edu Bridge Network operates.</li>
        </ul>
      </NumberedSection>
    </section>
  </PublicLayout>
);

const NumberedSection = ({ n, title, children }) => (
  <div className="mt-8">
    <h2 className="text-xl font-bold text-[#1A2A4F]">{n}. {title}</h2>
    <div className="mt-3 text-gray-600 leading-relaxed">{children}</div>
  </div>
);

export default TermsPage;
